module.exports = __webpack_public_path__ + "img/web-img3.3ddbbaaf.png";